<template>
  <div>
    <PendingPRs/>
  </div>
</template>

<script>
// @ is an alias to /src
import PendingPRs from '@/components/PendingPR.vue'

export default {
  name: 'approve-request-view',
  components: {
    PendingPRs
  }
}
</script>
